import { API_DOMAIN } from "@monorepo/constants";
import { ICoupon, ICouponsResponse } from "@monorepo/types";
import { createApi } from "@reduxjs/toolkit/query/react";

import { customBaseQuery } from "../../helpers/baseQuery";

export const couponsApi = createApi({
  reducerPath: "couponsApi",
  baseQuery: customBaseQuery({
    baseUrl: API_DOMAIN,
  }),
  tagTypes: ["UsedClientCoupons", "ClientCoupons", "ReservedClientCoupons"],
  endpoints: (builder) => ({
    getClientCoupons: builder.query<Array<ICoupon>, void>({
      query: () => ({
        url: "/api/v1/client-coupons",
      }),
      providesTags: ["ClientCoupons"],
      transformResponse: (response: ICouponsResponse, meta: any, error: any) => {
        if (error?.status === 404) {
          return [];
        }
        return response.data;
      },
      extraOptions: {
        serializeResponse: false,
      },
    }),
    getUsedClientCoupons: builder.query<Array<ICoupon>, void>({
      query: () => ({
        url: "/api/v1/used-client-coupons",
      }),
      providesTags: ["UsedClientCoupons"],
      transformResponse: (response: ICouponsResponse, meta: any, error: any) => {
        if (error?.status === 404) {
          return [];
        }
        return response.data;
      },
      extraOptions: {
        serializeResponse: false,
      },
    }),
    getUsedGlobalCoupons: builder.query<Array<ICoupon>, void>({
      query: () => ({
        url: "/api/v1/used-promotion-coupons",
      }),
      transformResponse: (response: ICouponsResponse, meta: any, error: any) => {
        if (error?.status === 404) {
          return [];
        }
        return response.data;
      },
      extraOptions: {
        serializeResponse: false,
      },
    }),

    getReservedClientCoupons: builder.query<Array<ICoupon>, void>({
      query: () => ({
        url: "/api/v1/reserved-client-coupons",
      }),
      providesTags: ["ReservedClientCoupons"],
      transformResponse: (response: ICouponsResponse, meta: any, error: any) => {
        if (error?.status === 404) {
          return [];
        }

        return response.data;
      },
      extraOptions: {
        serializeResponse: false,
      },
    }),
  }),
});

export const {
  useGetClientCouponsQuery,
  useGetUsedClientCouponsQuery,
  useGetUsedGlobalCouponsQuery,
  useGetReservedClientCouponsQuery,
} = couponsApi;

export default couponsApi.reducer;
